exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-resentation{margin-bottom:10px;font-weight:700}.Slide{padding:0 20px}.Slide,.Slide .item{width:100%;display:flex}.Slide .item{position:relative;height:calc(100vh - 254px)}.Slide .item .container-item{position:absolute;display:flex;align-items:center;justify-content:center;width:100%;height:100%;top:0;left:0}.Slide .item .container-item .ItemImage{width:100%;height:100%;background-position:50%;background-size:contain;background-repeat:no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Slider/components/Slide/style.scss
// module id = 5286
// module chunks = 0